<app-button-modal
    title="Webshop {{ user && user.isActive ? 'de' : 're' }}activeren"
    subtitle="Weet je het zeker?"
    [buttons]="buttons"
    allowExit="true"
></app-button-modal>
